export const CACHE_TIME_2000 = {
  gcTime: 2000,
  staleTime: 2000
};
export const HTTP_OK = 200;
export const HTTP_NO_CONTENT = 204;
